import { useEffect } from 'react';

export default function useResetScrollPosition() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
}
